import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FondeadoresService } from '../../../services/fondeadores.service';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color } from 'ng2-charts';
//Para PDF
import * as jsPDF from 'jspdf';
//PDF
import * as _html2canvas from "html2canvas";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

const html2canvas: any = _html2canvas;
declare const require: any;
require('jspdf-autotable');

@Component({
  selector: 'app-simulacion-esquema-inversion',
  templateUrl: './simulacion-esquema-inversion.component.html',
  styleUrls: ['./simulacion-esquema-inversion.component.scss']
})
export class SimulacionEsquemaInversionComponent implements OnInit {

  @Input() esquema_inversion: any = {};
  @Output()
  enviaFlag: EventEmitter<boolean> = new EventEmitter<boolean>();

  //public esquema_inversion: any = {};
  public interes: number = 0;
  public valor_diario: number = 0;
  public arrayDias: any = [];
  public rendimiento: number = 0;
  public dias: number = 0;
  public tasa_mensual: number = 0;
  public simulacion: boolean = false;
  public isLoading: boolean = false;
  //Gráfica de barras
  public barChartOptions: ChartOptions = {};
  
  public barChartLabels: string[];
  public barChartType: ChartType;
  public barChartLegend = true;
  public barChartData: ChartDataSets[];
  public barChartColors: Color[] = [ { backgroundColor: [] }];
  public muestraBarras: boolean = false;

  //Nuevas variables
  public inversion : any = {};
  public inversiones_fondeador : any [] = [];  
  public numMeses: number = 0;
  public fechaTemp: any = null;

  public chartClicked(e:any): void {
    try {
      
    } catch (err) {}
  }
  public chartHovered(e:any): void {
    console.log(e);
  }

  constructor(
    private fondeadoresService: FondeadoresService,
    //public dialogRef: MatDialogRef<SimulacionEsquemaInversionComponent>,
    // @Inject (MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    console.log("Entro al componente",this.esquema_inversion);
    this.obtenerInversiones();
  }

  public obtenerInversiones(){
    this.inversion = this.esquema_inversion;
    var fechaPago = this.inversion.fecha_inicio_inversion;
    //Obtenemos el dia del pago
    fechaPago = fechaPago.split(" ")[0].split("-")[2];
    
    console.log("Inversión ModalAbierto: ", this.inversion);
    
    if(this.inversion.capitalizacion == 1){
      this.inversion.capitaliza = "Si capitaliza intereses"
    }
    if(this.inversion.capitalizacion == 2){
      this.inversion.capitaliza = "Retiro mensual de los intereses"
    }
    if(this.inversion.capitalizacion == 3){
      this.inversion.capitaliza = "No capitaliza (retira al final)"
    }
    
    //Obtener tasa de interés mensual y la de retención
    var interes = this.inversion.tasa_interes/12
    this.inversion.tasa_interes_mensual = Math.round((interes + Number.EPSILON) * 100)/100;
    if(this.inversion.retencion_impuestos == "si"){
      var retencion = this.inversion.tasa_retencion/12;
      this.inversion.tasa_retencion_mensual = Math.round((retencion + Number.EPSILON) * 100)/100;
    }

    //console.log("Inversiones", this.inversiones_fondeador);
    if(this.inversion.tipo_fondeador == "inversionista"){
      this.inversion.dia_pagos = fechaPago;
      this.inversion.total_inversion = this.inversion.monto;
      //this.inversion.pago_interes = (this.inversion.total_inversion * this.inversion.tasa_interes_mensual)/100;
      this.inversion.tasa_interes_diaria = ((this.inversion.tasa_interes/100)/360);
      // this.inversion.tasa_retencion_diaria = ((this.inversion.tasa_retencion/100)/360);
      this.inversion.tasa_retencion_diaria = ((this.inversion.tasa_retencion/100));
      this.inversion.pago_interes = (this.inversion.tasa_interes_diaria * (this.inversion.total_inversion * 30));
      this.numMeses = this.inversion.plazo/30;
      //Copiamos el json al nuevo arreglo
      for (let i = 0; i < this.numMeses; i++) {
        if (i == 0){
          //Al ser una inversión el primer pago no genera intereses y se tiene que asignar para que lo tome encuenta la simulación
          this.inversiones_fondeador.push(Object.assign({} , this.inversion));
          this.inversiones_fondeador[0].pago_interes=0;
          this.inversiones_fondeador[0].total_inversion=0;
        }else{
          this.inversiones_fondeador.push(Object.assign({} , this.inversion));
        }
      }
      console.log("Array de Inversion: ", this.inversiones_fondeador);
      this.calcularTablaInversion();
      
    }
  }

  //Función principal
  public calcularTablaInversion(){    
    
    var fecha = this.inversiones_fondeador[0].fecha_inicio_inversion.split(" ")[0];
    var dia = parseInt(fecha.split("-")[2]);
    var mes = parseInt(fecha.split("-")[1]);
    var anio = parseInt(fecha.split("-")[0]);
    
    //Asignamos las fechas de pago
    for (let i = 0; i < this.numMeses; i++) {
      this.inversiones_fondeador[i].fecha_pago = (anio+"-"+mes+"-"+dia);
      this.inversiones_fondeador[i].pago_despues_impuestos = 0;
      this.inversiones_fondeador[i].pago_realizado = "";
      this.inversiones_fondeador[i].estatus_pago = "";
      //this.inversiones_fondeador[i].monto_incremento = 0;
      //Verificamos si retiene impuestos
      if(this.inversion.retencion_impuestos == "si"){
        //Si la inversión si capitaliza intereses y retiene impuestos        
        if(this.inversion.capitalizacion == 1){
          //SI CAPITALIZA
          //No acumula, si capitaliza y retira al final
          let monto_desp_impuestos = 0;
          if(i == 0){
            //monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
            monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria) * this.inversiones_fondeador[i].pago_interes);
            this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
          }else{
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_despues_impuestos;
            this.inversiones_fondeador[i].pago_interes = ( this.inversiones_fondeador[i].tasa_interes_diaria * (this.inversiones_fondeador[i].total_inversion * 30));
            //this.inversiones_fondeador[i].pago_interes = (this.inversiones_fondeador[i].total_inversion * this.inversiones_fondeador[i].tasa_interes_mensual)/100;
            monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria) * this.inversiones_fondeador[i].pago_interes);
            //monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
            //Nueva columna para pago después de impuestos
            this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
          }
          
        }else if(this.inversion.capitalizacion == 2){
          //No acumula, no capitaliza y retira mensual
          let monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria) * this.inversiones_fondeador[i].pago_interes);
          //let monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
          //Nueva columna para pago después de impuestos
          this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
        }else if(this.inversion.capitalizacion == 3){
          //NO CAPITALIZA
          //Acumula, no capitaliza y retira al final
          if(i == 0){
            //monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
            let monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria) * this.inversiones_fondeador[i].pago_interes);
            this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
          }else{
            this.inversiones_fondeador[i].total_inversion = (this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto + this.inversiones_fondeador[i-1].pago_despues_impuestos);
            this.inversiones_fondeador[i].pago_interes = ( this.inversiones_fondeador[i].tasa_interes_diaria * (this.inversiones_fondeador[i].total_inversion * 30));
            let monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - ((this.inversiones_fondeador[i].tasa_retencion_diaria) * this.inversiones_fondeador[i].pago_interes);
            //monto_desp_impuestos = this.inversiones_fondeador[i].pago_interes - (this.inversiones_fondeador[i].pago_interes * this.inversiones_fondeador[i].tasa_retencion_mensual)/100;
            //Nueva columna para pago después de impuestos
            this.inversiones_fondeador[i].pago_despues_impuestos = monto_desp_impuestos;
          }
        }
      }else{
        //NO RETIENE IMPUESTOS
        //Si la inversión si capitaliza intereses y no retiene impuestos
        if(this.inversion.capitalizacion == 1){
          if(i > 0){
            this.inversiones_fondeador[i].total_inversion = this.inversiones_fondeador[i-1].total_inversion  + this.inversiones_fondeador[i-1].pago_interes;
            this.inversiones_fondeador[i].pago_interes = (this.inversiones_fondeador[i].total_inversion * this.inversiones_fondeador[i].tasa_interes_mensual)/100;
            
          }
        }else if(this.inversion.capitalizacion == 3){
          if(i >0){
            this.inversiones_fondeador[i].total_inversion = ( this.inversiones_fondeador[i-1].total_inversion + this.inversiones_fondeador[i].monto );
            this.inversiones_fondeador[i].pago_interes = ( this.inversiones_fondeador[i].tasa_interes_diaria * (this.inversiones_fondeador[i].total_inversion * 30));
          }
        }
      }
      
      mes++;
			if(mes>12){
				mes = 1;
				anio++;
			}
      
    }
  }

  //Tabla anterior para la gráfica
  public calcularEsquemaInversion(){
    this.barChartLabels = [];
    this.barChartType = 'horizontalBar';
    this.barChartLegend = true;
    this.barChartData = [ { data: [], label:''}, { data: [], label:''}];
    this.barChartColors = [ { backgroundColor: '#0081ED' }, { backgroundColor: '#35CA51' }]
    this.muestraBarras = false;

    this.interes = (this.esquema_inversion.monto * this.esquema_inversion.tasa)/100;
    this.valor_diario = (this.interes/30);
    var numMeses = (this.esquema_inversion.plazo/30);
    var barDataInversion: Array <number> = [];
    var barDataRendimiento: Array <number> = [];

    for (let i = 0; i < numMeses; i++) {
      this.tasa_mensual = (this.esquema_inversion.tasa/100);
      this.dias = (i+1)*30;
      this.rendimiento = Math.round(((this.tasa_mensual/30)*this.dias)*this.esquema_inversion.monto);
      
      this.arrayDias.push({ dias: this.dias, rendimiento:this.rendimiento});
      this.barChartLabels.push(this.dias.toString());
      barDataInversion.push(this.esquema_inversion.monto);
      barDataRendimiento.push(this.rendimiento);
    }
   
    this.barChartData[0]=({data:barDataInversion, label: 'Inversión', stack: 'a'});
    this.barChartData[1]=({data:barDataRendimiento, label: 'Rendimiento', stack: 'a'});

    //Asignamos rangos para los valores que se muestran en la gráfica
    let valMin = this.esquema_inversion.monto-100000;
    let valMax = barDataRendimiento[barDataRendimiento.length-1]+25000+this.esquema_inversion.monto;
    console.log("Min: ",valMin," Max: ",valMax);
    
    //Opciones para la gráfica
    this.barChartOptions = {
      responsive: true,
      scales: { 
        xAxes: [{
          ticks: {
            min: valMin,
            max: valMax,
            stepSize: 50000,
            lineHeight:1.5,
            fontSize: 14
          },
          display: true,
          scaleLabel: {
            display: true,
            labelString: 'Inversión',
            lineHeight:3,
            fontSize: 16,
            fontStyle: "bold",
          }
        }], 
        yAxes: [{
          ticks: {
            lineHeight:1.5,
            fontSize: 14
          },
          scaleLabel: {
            display: true,
            labelString: 'Días',
            lineHeight:3,
            fontSize: 16,
            fontStyle: "bold",
          }
        }] 
      },
    }
    
    console.log("BarChart: ", this.barChartData);
    
  }

  public close(){
    console.log("flag: ", this.simulacion);
    this.enviaFlag.emit(this.simulacion);
    
  }

  //Función para crear PDF
  //Alternatibva para guardar pdf pero renderiza el html
  public downloadPDF() {
    this.isLoading=true;
    // Extraemos el
    const DATA = document.getElementById('htmlData');
    //const jsPDF = require('jspdf')
    const doc = new jsPDF('p');
    const options = {
      background: 'white',
      scale: 3
    };
    html2canvas(DATA, options).then((canvas) => {

      const img = canvas.toDataURL('image/jpg');
      // Add image Canvas to PDF
      const bufferX = 15;
      const bufferY = 15;
      const imgProps = (doc as any).getImageProperties(img);
      const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(img, 'JPEG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
      return doc;
    }).then((docResult) => {
      this.isLoading=false;
      docResult.save("Simulacion_Plazo"+this.esquema_inversion.plazo+"dias");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/simulacion-esquema-inversion/simulacion-esquema-inversion.component.ts